<template lang="pug">
.dropdownSelectOptionComponent(
  :class="[optionClasses]",
  @click="onClick",
  :title="option.label"
) {{ option.label }}
</template>

<script>
export default {
  props: {
    option: {
      type: Object,
      default: null
    },
    isSelected: Boolean,
    isDisabled: Boolean
  },
  emits: ['select', 'deselect'],
  computed: {
    optionClasses () {
      return {
        _selected: this.isSelected,
        _disabled: this.isDisabled
      }
    }
  },
  methods: {
    onClick () {
      if (!this.isDisabled) this.$emit(this.isSelected ? 'deselect' : 'select')
    }
  }
}
</script>

<style lang="sass" scoped>
.dropdownSelectOptionComponent
  overflow: hidden
  padding: $u 2*$u
  border-radius: 2*$u
  @include font('t18-regular')

  &:hover:not(._disabled)
    cursor: pointer
    color: $cLightBlue

  &._selected
    background-color: $cElements
    color: $cDarkBlue
</style>
